// Pàgines internes de l'Hotel Camprodon per slug (PaginasController::paginaHotelCamprodon).
import Actividades from "./Actividades.jsx";
import BarAlbeniz from "./BarAlbeniz.jsx";
import Bodas from "./Bodas.jsx";
import Camprodon from "./Camprodon.jsx";
import Empresas from "./Empresas.jsx";
import Eventos from "./Eventos.jsx";
import Galeria from "./Galeria.jsx";
import Grupos from "./Grupos.jsx";
import Habitaciones from "./Habitaciones.jsx";
import Hotel from "./Hotel.jsx";
import Newsletter from "./Newsletter.jsx";
import Oferta2Noches from "./Oferta2Noches.jsx";
import Ofertas from "./Ofertas.jsx";
import QueHacer from "./QueHacer.jsx";
import Restaurante from "./Restaurante.jsx";
import Servicios from "./Servicios.jsx";

const PAGINES = {
    "actividades": Actividades,
    "bar-albeniz": BarAlbeniz,
    "bodas": Bodas,
    "camprodon": Camprodon,
    "empresas": Empresas,
    "eventos": Eventos,
    "galeria": Galeria,
    "grupos": Grupos,
    "habitaciones": Habitaciones,
    "hotel": Hotel,
    "newsletter": Newsletter,
    "oferta-2-noches": Oferta2Noches,
    "ofertas": Ofertas,
    "que-hacer": QueHacer,
    "restaurante": Restaurante,
    "servicios": Servicios,
};

export default PAGINES;
